import React from 'react';
import { Box, Skeleton } from '@mui/material';

type GraphNodeSkeletonProps = {
  bars?: number;
};

function GraphNodeSkeleton({ bars = 5 }: GraphNodeSkeletonProps) {
  return (
    <>
      <Box display='flex' justifyContent='center' mb={2}>
        <Skeleton
          variant='text'
          sx={{
            fontSize: '1.6rem',
            width: `${30 + Math.random() * 70}%`,
          }}
          animation='wave'
        />
      </Box>
      <Box
        display='flex'
        justifyContent='center'
        alignItems='flex-end'
        gap={2}
        height={150}
        mb={2}
        px={5}
      >
        {[...Array(bars)].map((_, idx) => (
          <Box
            key={idx}
            display='flex'
            flexDirection='column'
            alignItems='center'
            width='100%'
          >
            <Skeleton
              variant='rectangular'
              animation='wave'
              sx={{
                maxWidth: 170,
                width: '100%',
                height: `${50 + Math.random() * 100}px`,
              }}
            />
          </Box>
        ))}
      </Box>
    </>
  );
}

export default GraphNodeSkeleton;
